<footer class="text-xs-center">
    <div class="float-right hidden-xs">
        <b><span translate>Version</span></b> {{version}}
    </div>
    <strong id="copyright">{{'Copyright' | translate}} © {{year}} <a href="http://www.actual.si/">Actual I.T.</a></strong> <span>{{'All rights reserved' | translate}}.</span>
</footer>